import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'extractDomain'
})
export class ExtractDomainFilterPipe implements PipeTransform {
    transform(url: string){
        try{
            let hostname;
            if (url.indexOf('://') > -1) {
                hostname = url.split('/')[2];
            }else {
                hostname = url.split('/')[0];
            }
            if(url.indexOf('www.') > -1){
                hostname = hostname.split('www.')[1];
            }
            return hostname.split(':')[0].split('?')[0];
        }catch(err){
            console.log(err);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pipes/extractDomain.filter.ts